export default {
      id: "unit__reefer-usage",
      viewBox: "0 0 24 26",
      url: __webpack_public_path__ + "img/icons.svg#unit__reefer",
      toString: function () {
        return this.url;
      }
    }